import { AfterContentInit, AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ResourceManagerService } from 'src/app/marketplace/core/services/resource-manager.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { LazyLoad } from '@app/helpers/lazyload';
import { LoaderService } from '@app/marketplace/core/services/loader.service';
import { Observable } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as cartActions from "@app/marketplace/products/state/shopping-cart/cart-action";
import * as searchActions from "@app/marketplace/products/state/product-search/search-actions";
import { Store } from '@ngrx/store';
const lazyLoad = LazyLoad;

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  animations: [
    trigger('fade', [
      state('true', style({ display: "inline", opacity: 1 })),
      state('false', style({ display: "none", opacity: 0 })),
      transition('true <=> false', animate('1s ease-in-out')),
    ]),
  ]
})
export class LayoutComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
  public isLoading$: Observable<boolean>;
  constructor(
    private loaderService: LoaderService,
    private resourceManager: ResourceManagerService,
    private store: Store<any>,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId,
  ) { this.isLoading$ = this.loaderService.isLoading$; }

  ngAfterContentInit(): void {
    /*this.resourceManager.loadStyles('dd');
    this.resourceManager.loadScripts('dd').then(response => {console.info(response)});*/
  }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.store.dispatch(cartActions.FetchCart());
      this.store.dispatch(searchActions.DeleteSearchTerm());
      $(document).on("keypress", function (e) {
        if (e.which == 13) {
          e.preventDefault();
          console.info("keypress");
          this.store.dispatch(searchActions.SearchProducts());
        }
      }.bind(this));
    }
  }
  ngAfterViewInit(): void {
    this.loaderService.hide();
  }
  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId))
      this.resourceManager.unloadResources(this.document);
  }
}
